<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('serviceRequest.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('serviceRequest.pageTitle'),
          href: '/admin/service-requests'
        },
        {
          text: $t('view'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <Tabs @on-click="onTabChange">
            <TabPane label="Detail" icon="ios-book" name="detail">
              <h2 class="ts-text-gray-800 ts-text-base">
                <span>
                  {{ $t('serviceRequest.serviceRequestNo') }} :
                  {{ resource.service_request_no }}
                </span>
                <a href="#" v-tooltip="$t('serviceRequest.requestPhoto')" class="text-primary ts-ml-3"
                  @click.prevent="() => (showRequestPhoto = true)">
                  <i class="fas fa-image"></i>
                </a>
                <a href="#" v-tooltip="$t('serviceRequest.gisLocation')" class="text-success ts-ml-3"
                  @click.prevent="() => (showGisLocation = true)">
                  <i class="fas fa-map-marker-alt"></i>
                </a>
                <span class="ts-pl-3">
                  <span>{{ $t('serviceRequest.totalOrderService') }} :</span>
                  <span class="ts-text-blue-700">
                    {{ totalOrderAmount ? $currencyFormat(totalOrderAmount) : '0' }}
                  </span>
                </span>
                <span class="ts-pl-3">
                  <span>{{ $t('serviceRequest.totalSoldService') }} :</span>
                  <span class="ts-text-blue-700">
                    {{ totalSoldAmount ? $currencyFormat(totalSoldAmount) : '0' }}
                  </span>
                </span>
              </h2>

              <p class="ts-mt-2 ts-pl-3">
                {{ $t('serviceRequest.remarks') }}:
                {{ resource.remarks }}
              </p>
              <TaskViewDetail :resource="resource" />
              <ProgressStep :resource="resource" />
              <!-- <div class="ts-flex ts-space-x-3 ts-items-center ts-mt-6">
                <h2 class="ts-text-gray-500 ts-text-base ts-capitalize ts-mb-0">
                  <i class="fas fa-paperclip ts-mr-3"></i>
                  {{ $t('task.attachment') }}
                </h2>
                <button
                  @click.prevent="openBrowseFile"
                  class="ts-w-6 ts-h-6 ts-bg-blue-500 ts-rounded-full ts-flex ts-items-center ts-justify-center focus:ts-outline-none"
                >
                  <Icon type="ios-add" size="20" class="ts-text-white" />
                </button>
                <input type="file" ref="file" @change="addMoreAtt" />
              </div> -->
              <!-- <ViewAttachment :resource="resource" /> -->
              <!-- <div class="ts-w-56" v-if="is_uploading">
                <Progress :percent="progressUploading" :stroke-width="10" />
              </div> -->
              <div v-if="borrowingSparePart">
                <div v-for="(item, index) in borrowingSparePart" :key="index">
                  <BorrowingSparePart :borrowingSparePart="item" />
                </div>
              </div>
            </TabPane>
            <TabPane label="Comment" icon="md-book" name="comment">
              <!-- <Comment /> -->
              <div class="ts-flex ts-items-center ts-w-full ts-h-full ts-justify-center">
                <img class="ts-w-40 ts-object-contain"
                  src="https://t3.ftcdn.net/jpg/00/51/45/62/360_F_51456278_3y8SC99iozvWZZXfUdtJ21TlJaqgQHWK.jpg"
                  alt="" />
              </div>
            </TabPane>
            <TabPane label="History" icon="ios-clock" name="history">
              <HistoryTab v-if="active_tab === 'history'" :resources="resource.logs" />
            </TabPane>
          </Tabs>
        </ts-loading-banner>
      </ts-card-wrapper>
      <a-modal v-if="showRequestPhoto" v-model="showRequestPhoto" :title="$t('serviceRequest.requestPhoto')"
        :footer="null" :centered="true" :maskClosable="false" :zIndex="1000">
        <img class="ts-h-2/3 ts-rounded ts-object-contain" v-lazy="{
          src: resource.request_photo,
          error: require('@/assets/default-image.jpg'),
          loading: require('@/assets/Rolling-1s-200px_2.svg')
        }" />
      </a-modal>
      <a-modal v-if="showGisLocation" v-model="showGisLocation" :title="$t('serviceRequest.gisLocation')" :footer="null"
        :centered="true" :maskClosable="false" :zIndex="1000" width="50%">
        <GisLocation :resource="resource" />
      </a-modal>
    </ts-card>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import TaskViewDetail from './components/view/task-view-detail.vue'
import ProgressStep from './components/view/progress-step.vue'
import BorrowingSparePart from './components/view/borrowing-spare-part.vue'
// import ViewAttachment from './components/view-attachment.vue'
// import Comment from './components/view/comment.vue'
import HistoryTab from './components/view/history-tab.vue'
import GisLocation from './components/view/gis-location.vue'
import Form from './form.vue'

export default {
  components: {
    TaskViewDetail,
    ProgressStep,
    BorrowingSparePart,
    // ViewAttachment,
    // Comment,
    HistoryTab,
    GisLocation,
    Form
  },
  data() {
    return {
      showRequestPhoto: false,
      showGisLocation: false,
      loading: false,
      is_uploading: false,
      is_show_update_report: false,
      show_product_detail: false,
      viewReportDate: undefined,
      progressUploading: 0,
      active_tab: 'detail',
      resource: {},
      subTaskResources: []
    }
  },
  computed: {
    default_currency_sign() {
      return this.$store.state.authUser.sys_setting.default_currency_sign
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    },
    borrowingSparePart() {
      if (this.resource.borrowing_spare_part) {
        return this.resource.borrowing_spare_part
      }
      return null
    },
    totalOrderAmount() {
      if (this.borrowingSparePart) {
        return this.borrowingSparePart.reduce((total, part) => {
          const detailSum = part.details.reduce((subTotal, detail) => {
            return subTotal + detail.sale_price * detail.quantity_order;
          }, 0);
          return total + detailSum;
        }, 0);
      }
      return 0;
    },
    totalSoldAmount() {
      if (this.borrowingSparePart) {
        return this.borrowingSparePart.reduce((total, part) => {
          const detailSum = part.details.reduce((subTotal, detail) => {
            return subTotal + detail.sale_price * detail.quantity_sold;
          }, 0);
          return total + detailSum;
        }, 0);
      }
      return 0;
    }
  },
  methods: {
    ...mapActions('serviceManagement/serviceRequest', [
      'preview',
      'addAttachments',
      'removeAttachments',
      'report'
    ]),
    onTabChange(tab) {
      this.active_tab = tab
    },
    findServiceRequestById(id) {
      this.loading = true
      this.preview(id)
        .then(response => {
          this.resource = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    openBrowseFile() {
      this.$refs.file.click()
    },
    addMoreAtt(event) {
      var config = {
        onUploadProgress: progressEvent => {
          this.progressUploading = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          )
        }
      }
      let form = new FormData()
      form.append('file', event.target.files[0])
      this.is_uploading = true
      this.addAttachments({
        id: this.$route.params.id,
        data: form,
        config
      })
        .then(response => {
          this.resource.attachments.push(response.attachment)
        })
        .finally(() => (this.is_uploading = false))
    },
    onReport() {
      this.is_show_update_report = false
      this.findServiceRequestById(this.$route.params.id)
    },
    onShowProductDetail(date) {
      this.show_product_detail = true
      this.viewReportDate = date
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.findServiceRequestById(to.params.id)
    })
  }
}
</script>
<style scoped>
* {
  font-family: Roboto, Khmer, 'Font Awesome 5 Free';
}
</style>
